import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=5cf5715f&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=5cf5715f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf5715f",
  null
  
)

export default component.exports